import type { ButtonHTMLAttributes, ReactNode } from 'react'

import { cn } from '../lib/cn'

export type ButtonShadowProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  faceClassName?: string
  shadowClassName?: string
  children: ReactNode
}

export const ButtonShadow = ({
  className,
  faceClassName,
  shadowClassName,
  children,
  ...props
}: ButtonShadowProps): JSX.Element => (
  <button
    className={cn('group relative inline-flex cursor-pointer', className)}
    {...props}
  >
    <span
      className={cn(
        'absolute inset-0 translate-x-0 translate-y-0 rounded-[14px] opacity-0 transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] group-hover:-translate-x-px group-hover:-translate-y-px group-hover:opacity-100 group-active:translate-x-0 group-active:translate-y-0',
        shadowClassName,
      )}
    />
    <span
      className={cn(
        'relative z-10 flex w-full items-center justify-center whitespace-nowrap rounded-[14px] border-2 border-dune-text bg-white px-6 py-2.5 font-display text-sm font-semibold tracking-tight text-dune-text transition-transform duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] group-hover:translate-x-px group-hover:translate-y-px group-active:translate-x-0 group-active:translate-y-0',
        faceClassName,
      )}
    >
      {children}
    </span>
  </button>
)
